import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

export const i18n = new VueI18n({
locale: 'en', 
fallbackLocale: 'cn', 
messages,
});

const messages = {    
    en : {        welcomeMsg: 'Welcome to Connect2'           },
    cn : {        welcomeMsg: 'Connect2 ciao ni ma lul'    }
};